<div
  [ngClass]="{'border-bottom-0': hideBorder}"
  class="py-2 pt-md-0 pb-md-4 contract-item-container"
  data-e2e="contracts-options"
>
  @if (icon) {
  <div>
    <img alt="" [src]="icon" />
  </div>
  }
  <div class="row">
    <div class="col-12 col-md-6 col-lg-5">
      <h2 class="h3 mb-0" data-e2e="offerName">{{protectedHouseContractViewModel?.offerName}}</h2>
      <div class="lead text-gray3">{{protectedHouseContractViewModel?.detail}}</div>
    </div>
    <div class="col-12 col-md-6 col-lg-7 mt-1 mt-md-0 btn-center">
      @for (message of protectedHouseContractViewModel?.messages; track message) {
      <p class="text-left text-mw">{{message}}</p>
      } @if (protectedHouseContractViewModel?.linkInternet) {
      <div class="d-flex justify-content-center justify-content-md-start">
        <div class="d-flex flex-column">
          <a
            class="btn btn-secondary"
            [href]="protectedHouseContractViewModel?.linkInternet | link | async"
            (click)="openProtectedHouseContract(protectedHouseContractViewModel?.linkInternet);false"
          >
            {{protectedHouseContractViewModel.button}}</a
          >
        </div>
      </div>
      }
    </div>
  </div>
</div>
